import React from "react";
import { Box } from "@chakra-ui/react";
function SVG(props) {
    return React.createElement(Box, Object.assign({ as: "svg", h: "1em", w: "1m", fontSize: "1em" }, props));
}
export function EmojiIcon() {
    return (React.createElement(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", focusable: "false", name: "emoji" },
        React.createElement("path", { d: "M12 1a11 11 0 1 0 11 11A11.013 11.013 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9.011 9.011 0 0 1-9 9zm6-8a6 6 0 0 1-12 0 1 1 0 0 1 2 0 4 4 0 0 0 8 0 1 1 0 0 1 2 0zM8 10V9a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0zm6 0V9a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0z" })));
}
export function SupportIcon() {
    return (React.createElement(SVG, { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: "false", name: "support" },
        React.createElement("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("circle", { cx: "11.9995", cy: "12", r: "4.45455", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("path", { d: "M12 6.99998V2.90907", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("path", { d: "M2.90909 12L7 12", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("path", { d: "M16.5458 12L20.6367 12", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("path", { d: "M12 20.6364V16.5455", stroke: "currentColor", strokeWidth: "2" })));
}
//# sourceMappingURL=CustomIcons.js.map